const Chat = () => import('views/chat/Chat')
const ChatList = () => import('views/chat/ChatList')
const ChatDialogue = () => import('views/chat/ChatDialogue')
const ChatAddressBook = () => import('views/chat/ChatAddressBook')
const ChatMe = () => import('views/chat/ChatMe')

export default {
  path: '/chat',
  name: 'Chat',
  component: Chat,
  redirect: '/chat/list',
  meta: { needAuth: true, roles: ['tnb_disk'] },
  children: [
    {
      path: '/chat/list',
      name: 'ChatList',
      component: ChatList,
      meta: { title: '聊天', needAuth: true, roles: ['tnb_disk'] }
    },
    {
      path: '/chat/dialogue',
      name: 'ChatDialogue',
      component: ChatDialogue,
      meta: { title: 'xxx', needAuth: true, roles: ['tnb_disk'] }
    },
    {
      path: '/chat/contact',
      name: 'ChatAddressBook',
      component: ChatAddressBook,
      meta: { title: '通讯录', needAuth: true, roles: ['tnb_disk'] }
    },
    {
      path: '/chat/me',
      name: 'ChatMe',
      component: ChatMe,
      meta: { title: '我', needAuth: true, roles: ['tnb_disk'] }
    }
  ]
}
